import { RefObject, useEffect } from "react";
import useToggle from "./useToggle";

function useOnClickOutside(ref: RefObject<HTMLDivElement>) {
  const { show, setShow, toggle } = useToggle();
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (
        !ref.current ||
        (event.target instanceof HTMLElement &&
          ref.current.contains(event.target))
      ) {
        return;
      }

      setShow(false);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref]);

  return {
    show,
    setShow,
    toggle,
  };
}

export default useOnClickOutside;
